"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return Sort;
    }
});
const _Model = /*#__PURE__*/ _interop_require_default(require("~/models/Model"));
const _Column = /*#__PURE__*/ _interop_require_default(require("~/models/Column"));
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _globals = require("~/utils/globals");
const _NocoCache = /*#__PURE__*/ _interop_require_default(require("~/cache/NocoCache"));
const _extractProps = require("~/helpers/extractProps");
const _View = /*#__PURE__*/ _interop_require_default(require("~/models/View"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let Sort = class Sort {
    // skip viewWebhookManager for this, Sort.deleteAll is not a standalone operation, it's invoked by view service
    static async deleteAll(context, viewId, ncMeta = _Noco.default.ncMeta) {
        await _NocoCache.default.deepDel(context, `${_globals.CacheScope.SORT}:${viewId}`, _globals.CacheDelDirection.PARENT_TO_CHILD);
        await ncMeta.metaDelete(context.workspace_id, context.base_id, _globals.MetaTable.SORT, {
            fk_view_id: viewId
        });
        // on delete, delete any optimised single query cache
        {
            const view = await _View.default.get(context, viewId, ncMeta);
            await _View.default.clearSingleQueryCache(context, view.fk_model_id, [
                view
            ], ncMeta);
        }
    }
    static async insert(context, sortObj, ncMeta = _Noco.default.ncMeta) {
        var _this;
        const insertObj = (0, _extractProps.extractProps)(sortObj, [
            'id',
            'fk_view_id',
            'fk_column_id',
            'fk_level_id',
            'direction',
            'base_id',
            'source_id'
        ]);
        // todo: implement a generic function
        insertObj.order = sortObj.push_to_top ? 1 : (+((_this = await ncMeta.knex(_globals.MetaTable.SORT).max('order', {
            as: 'order'
        }).where({
            fk_view_id: sortObj.fk_view_id
        }).first()) == null ? void 0 : _this.order) || 0) + 1;
        const model = await _Column.default.get(context, {
            colId: sortObj.fk_column_id
        }, ncMeta);
        if (!sortObj.source_id) {
            insertObj.source_id = model.source_id;
        }
        // increment existing order
        if (sortObj.push_to_top) {
            await ncMeta.knex(_globals.MetaTable.SORT).where({
                fk_view_id: sortObj.fk_view_id
            }).increment('order', 1);
        }
        const row = await ncMeta.metaInsert2(context.workspace_id, context.base_id, _globals.MetaTable.SORT, insertObj);
        if (sortObj.push_to_top) {
            const sortList = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.SORT, {
                condition: {
                    fk_view_id: sortObj.fk_view_id
                },
                orderBy: {
                    order: 'asc'
                }
            });
            await _NocoCache.default.setList(context, _globals.CacheScope.SORT, [
                sortObj.fk_view_id
            ], sortList);
        }
        // on insert, delete any optimised single query cache
        {
            const view = await _View.default.get(context, row.fk_view_id, ncMeta);
            await _View.default.clearSingleQueryCache(context, view.fk_model_id, [
                view
            ], ncMeta);
        }
        return this.get(context, row.id, ncMeta).then(async (sort)=>{
            if (!sortObj.push_to_top) {
                await _NocoCache.default.appendToList(context, _globals.CacheScope.SORT, [
                    sortObj.fk_view_id
                ], `${_globals.CacheScope.SORT}:${row.id}`);
                await _NocoCache.default.appendToList(context, _globals.CacheScope.SORT, [
                    sortObj.fk_column_id
                ], `${_globals.CacheScope.SORT}:${row.id}`);
            }
            return sort;
        });
    }
    getColumn(context, ncMeta = _Noco.default.ncMeta) {
        if (!this.fk_column_id) return null;
        return _Column.default.get(context, {
            colId: this.fk_column_id
        }, ncMeta);
    }
    static async list(context, { viewId }, ncMeta = _Noco.default.ncMeta) {
        if (!viewId) return null;
        const cachedList = await _NocoCache.default.getList(context, _globals.CacheScope.SORT, [
            viewId
        ]);
        let { list: sortList } = cachedList;
        const { isNoneList } = cachedList;
        if (!isNoneList && !sortList.length) {
            sortList = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.SORT, {
                condition: {
                    fk_view_id: viewId
                },
                orderBy: {
                    order: 'asc'
                }
            });
            await _NocoCache.default.setList(context, _globals.CacheScope.SORT, [
                viewId
            ], sortList);
        }
        sortList.sort((a, b)=>(a.order != null ? a.order : Infinity) - (b.order != null ? b.order : Infinity));
        return sortList.map((s)=>new Sort(s));
    }
    static async update(context, sortId, body, ncMeta = _Noco.default.ncMeta) {
        // set meta
        const res = await ncMeta.metaUpdate(context.workspace_id, context.base_id, _globals.MetaTable.SORT, {
            fk_column_id: body.fk_column_id,
            direction: body.direction
        }, sortId);
        await _NocoCache.default.update(context, `${_globals.CacheScope.SORT}:${sortId}`, {
            fk_column_id: body.fk_column_id,
            direction: body.direction
        });
        // on update, delete any optimised single query cache
        {
            const sort = await this.get(context, sortId, ncMeta);
            const view = await _View.default.get(context, sort.fk_view_id, ncMeta);
            await _View.default.clearSingleQueryCache(context, view.fk_model_id, [
                view
            ], ncMeta);
        }
        return res;
    }
    static async delete(context, sortId, ncMeta = _Noco.default.ncMeta) {
        const sort = await this.get(context, sortId, ncMeta);
        await ncMeta.metaDelete(context.workspace_id, context.base_id, _globals.MetaTable.SORT, sortId);
        await _NocoCache.default.deepDel(context, `${_globals.CacheScope.SORT}:${sortId}`, _globals.CacheDelDirection.CHILD_TO_PARENT);
        // on delete, delete any optimised single query cache
        if (sort == null ? void 0 : sort.fk_view_id) {
            const view = await _View.default.get(context, sort.fk_view_id, ncMeta);
            await _View.default.clearSingleQueryCache(context, view.fk_model_id, [
                view
            ], ncMeta);
        }
    }
    static async get(context, id, ncMeta = _Noco.default.ncMeta) {
        let sortData = id && await _NocoCache.default.get(context, `${_globals.CacheScope.SORT}:${id}`, _globals.CacheGetType.TYPE_OBJECT);
        if (!sortData) {
            sortData = await ncMeta.metaGet2(context.workspace_id, context.base_id, _globals.MetaTable.SORT, id);
            await _NocoCache.default.set(context, `${_globals.CacheScope.SORT}:${id}`, sortData);
        }
        return sortData && new Sort(sortData);
    }
    async getModel(context, ncMeta = _Noco.default.ncMeta) {
        return _Model.default.getByIdOrName(context, {
            id: this.fk_view_id
        }, ncMeta);
    }
    constructor(data){
        Object.assign(this, data);
    }
};
